import * as actions from './actions'
import * as getters from './getters'
import * as types from './types'

const state = {
  specialPriceActive: {}, // 活动价格数据
  specialOffers: {}, // 添加特价商品
  inputTimerScroll: null,
  specialSignReg: /[，。？！……～#：：、“”‘’（）\-；@*_~%&·•//,〈〉『』〔〕【】+−×÷=^!._@//?#!~…:;$%^&*()-+=“”‘’•|]/g,
  inputTextReg: /[^\d\w\u4E00-\u9FA5，。？！……～#：：、“”‘’（）\-；@*_~%&·•//,〈〉『』〔〕【】+−×÷=^!._@//?#!~…:;$%^&*()-+=“”‘’•|]/g, // 文本输入框检验正则表达式
  inputTextWithoutChineseReg: /[^\d，。？！……～#：：、“”‘’（）\-；@*_~%&·•//,〈〉『』〔〕【】+−×÷=^!._@//?#!~…:;$%^&*()-+=“”‘’•|]/g, // 数字 和 符号 输入正则表达式
  inputTextWithNumLetterReg: /[^\d\w，。？！……～#：：、“”‘’（）\-；@*_~%&·•//,〈〉『』〔〕【】+−×÷=^!._@//?#!~…:;$%^&*()-+=“”‘’•|]/g, // 数字,字母 和 符号 输入正则表达式
  selectedStoreList: [],
  clientHeight: 667,
  isGettedDesc: false,
  deliveryInfo: null,
  editorContent: ''
}

const mutations = {
  /**
   * @author lwq
   * @function 设置活动信息
   * @param {Object<specialPriceActive>} data
   * data 参数所有字段规范：
   *    activityId        {String} 活动ID
   *    goodsName         {String} 商品名称
   *    description       {String} 商品描述
   *    unit              {String} 商品规格
   *    originalPrice     {String} 商品原价
   *    activityPrice     {String} 商品活动价格
   *    goodsPictures     {List<String>} 商品图片地址集合
   *    goodsStock        {Integer} 商品库存数
   *    purchaseLimit     {Integer} 单人限购数
   *    activityName      {String}  活动名称
   *    activityStartTime {DateTime<YYYY-mm-dd HH:ii>} 活动开始时间
   *    activityEndTime   {DateTime<YYYY-mm-dd HH:ii>} 活动开始时间
   *    activityUserType  {Integer<1-全部；2-会员>} 参与用户类型
   *    uid               {Integer} 商户id
   *    outStoreIds       {List<String>}  门店id集合
   */
  /**
   * @author lwq
   * @param {Object} data
   * @function 更新活动价格数据
   */
  [types.SET_ALL_ACTIVIRY] (state, data) {
    state.specialPriceActive = Object.assign(state.specialPriceActive, data)
  },
  /**
   * @author lwq
   * @param {Object} data
   * @function 重新设置活动详情
   */
  [types.RESET_ALL_ACTIVIRY] (state, data) {
    state.specialPriceActive = data
  },
  /**
   * @author lwq
   * @function 将活动详情的图片信息设置为空对象
   */
  [types.EMPTY_ALL_ACTIVIRY] (state) {
    state.specialPriceActive = {}
  },
  /**
   * @author fmy
   * @function 添加特价商品-保存要编辑的特价商品详情
   */
  [types.SPECIAL_OFFERS] (state, data) {
    state.specialOffers = data
  },
  /**
   * @author billy
   * @function 添加特价商品-保存富文本图文详情内容
   */
  [types.SET_EDITOR_CONTENT](state, data) {
    state.editorContent = data
  },
  /**
   * @author lwq
   * @function 设置商品图片
   * @param {List<String>} data
   */
  [types.MODIFY_GOODS_PICTURE] (state, data) {
    state.specialPriceActive.goodsPictures = data
  },
  /**
   * @author lwq
   * @param {Object<goods>} data
   * @function 设置活动门店的列表
   */
  [types.MODIFY_GOODS_STORES] (state, data) {
    state.specialPriceActive.outStoreIds = data
  },
  /**
   * @author lwq
   * @param {List<storeInfo>} data
   *  storeInfo:
   *    store_id {Number} 门店id
   *    store_name {String} 门店名称
   *    address {String} 门店地址
   */
  [types.SET_STORE_LIST] (state, data) {
    state.selectedStoreList = data
  },
  /**
   * @function 清空门店选择
   * @author xuchen
   * @param {Object} state
   * @return void
   */
  [types.CLEAR_STORE_LIST] (state) {
    state.selectedStoreList = []
  },
  [types.SET_INPUT_TIMER_SCROLL] (state, value) {
    state.inputTimerScroll = value
  },
  [types.CLEAR_INPUT_TIMER_SCROLL] (state) {
    clearTimeout(state.inputTimerScroll)
  },
  [types.SET_CLIENT_HEIGHT] (state, clientHeight) {
    state.clientHeight = clientHeight
  },
  [types.SET_GOODS_DESC_STATUS] (state, data) {
    state.isGettedDesc = data
  },
  // 特价活动配送方式模块
  [types.CLEAR_DELIVERY_INFO] (state) {
    state.deliveryInfo = null
  },
  [types.SET_DELIVERY_INFO] (state, data) {
    state.deliveryInfo = data
  },
  [types.GET_DELIVERY_INFO] (state) {
    return state.isGettedDesc
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
